
<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="item.path" v-for="(item, index) in breadcrumbList" :key="index">{{ item.name
      }}</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.trainer" placeholder="输入用户名或手机号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="add()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
      style="width: 100%;">
      <el-table-column align="center" type="selection" width="40">
      </el-table-column>
      <el-table-column prop="trainer_user_id" label="ID" width="60">
      </el-table-column>
      <el-table-column prop="trainer_name" label="教练名" width="60">
      </el-table-column>
      <el-table-column prop="trainer_phone" label="手机号/账号" width="100">
      </el-table-column>

      <el-table-column prop="disable" label="是否禁用" width="100">
        <template slot-scope="{row}">
          <div v-if="row.disable == 0">未禁用</div>
          <div v-else>禁用</div>
        </template>
      </el-table-column>
      <el-table-column prop="is_dy" label="抖音平台" width="80">
        <template slot-scope="{row}">
          <div v-if="row.is_dy == 0">开放</div>
          <div v-else>未开放</div>
        </template>
      </el-table-column>
      <el-table-column prop="is_ks" label="快手平台" width="80">
        <template slot-scope="{row}">
          <div v-if="row.is_ks == 0">开放</div>
          <div v-else>未开放</div>
        </template>
      </el-table-column>
      <el-table-column prop="is_wx" label="微信平台" width="80">
        <template slot-scope="{row}">
          <div v-if="row.is_wx == 0">开放</div>
          <div v-else>未开放</div>
        </template>
      </el-table-column>
      <el-table-column prop="commission" label="抽成比例" width="100">
      </el-table-column>
      <el-table-column prop="pTrainer" label="上级代理" width="100">
      </el-table-column>
      <el-table-column prop="users" label="学员数量" width="100">
      </el-table-column>
      <el-table-column align="center" label="操作" width="auto">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="user(scope.row)"><i class="el-icon-search" />查询学员</el-button>
          <el-button size="mini" type="primary" @click="card(scope.row)"><i class="el-icon-search" />查询卡密</el-button>
          <el-button size="mini" type="primary" @click="setcard(scope.row)"><i class="el-icon-plus" />分配卡密</el-button>
          <el-button size="mini" type="primary" @click="update(scope.row)"><i class="el-icon-edit" />修改教练信息</el-button>
          <el-button size="mini" type="primary" @click="setpwd(scope.row)"><i class="el-icon-edit" />重置密码</el-button>
          <el-button size="mini" type="danger" @click="del(scope.row)"><i class="el-icon-delete" />删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <Add :show.sync="dialog.addDialogStatus" @refesh_list="getdata"></Add>
    <Update :info="updateInfo" :show.sync="dialog.updateDialogStatus" size="small" @refesh_list="getdata"></Update>
    <User :show.sync="dialog.userDialogStatus" :userid="userid"></User>
    <Card :show.sync="dialog.cardDialogStatus" :userid="userid"></Card>
    <el-dialog title="查询卡密" :visible.sync="dialog.setDialogStatus" width="500px">
      <el-row>
        <div style="display: flex; align-items: center;">
          <div style="width: 100px;">卡密数量:</div>
          <el-input type="number" min="0" v-model="setcards.num" autoComplete="off" clearable
            placeholder="请设置卡密个数"></el-input>
        </div>
        <div class="dialog-footer">
          <el-button size="small" :loading="loading" type="primary" @click="submit">
            <span v-if="!loading">确 定</span>
            <span v-else>提 交 中...</span>
          </el-button>
          <el-button size="small" @click="closeForm">取 消</el-button>
        </div>
      </el-row>
    </el-dialog>
    <el-dialog title="重置教练密码" :visible.sync="dialog.pwdDialogStatus" width="500px">
      <el-row>
        <div style="display: flex; align-items: center;">
          <div style="width: 100px;">密码修改:</div>
          <el-input type="text" v-model="setcards.trainer_pass" placeholder="请输入密码"></el-input>
        </div>
        <div class="dialog-footer">
          <el-button size="small" :loading="loading" type="primary" @click="submit1">
            <span v-if="!loading">确 定</span>
            <span v-else>提 交 中...</span>
          </el-button>
          <el-button size="small" @click="closeForm">取 消</el-button>
        </div>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import { getTrainer, getTrainerdelete, getTraineredit, setCard, editPass } from '../../api/userMG';
import Pagination from '../../components/Pagination'
import Update from './update.vue'
import Add from './Add.vue'
import User from './user.vue'
import Card from './setcard.vue'

export default {
  // 注册组件
  components: {
    Pagination, Update, Add, User, Card
  },
  data() {
    return {
      type: [

      ],
      dialog: {
        addDialogStatus: false,
        updateDialogStatus: false,
        userDialogStatus: false,
        setDialogStatus: false,
        cardDialogStatus: false,
        pwdDialogStatus: false

      },
      breadcrumbList: [],//面包屑
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      formInline: {
        page: 1,
        trainer: ''
      },
      updateInfo: {},
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      userid: 0,
      setcards: {
        trainer_user_id: '',
        trainer_pass: '',
        num: 0 //分配卡密秘数量
      },
    }
  },

  created() {
    this.getdata()
    this.generateBreadcrumb()
  },
  watch: {
    $route() {
      this.generateBreadcrumb()
    }
  },
  methods: {
    generateBreadcrumb() {
      // 获取当前路由信息
      const matched = this.$route.matched
      console.log(matched, '++++++++++');
      // 初始化面包屑导航数据
      const breadcrumbList = []
      // 遍历路由信息，生成面包屑导航数据
      matched.forEach(item => {
        const { meta, name, path } = item
        if (meta.requireAuth) {
          breadcrumbList.push({
            name,
            path
          })
        }
      })
      console.log(breadcrumbList, '=========');
      // 保存面包屑导航数据
      this.breadcrumbList = breadcrumbList
    },
    user(row) {
      console.log(row.trainer_user_id);
      this.userid = row.trainer_user_id * 1
      this.dialog.userDialogStatus = true
    },
    card(row) {
      console.log(row.trainer_user_id);
      this.userid = row.trainer_user_id * 1
      this.dialog.cardDialogStatus = true
    },
    //添加
    add() {
      console.log(1111);
      this.dialog.addDialogStatus = true
    },
    //修改
    update(row) {
      console.log(row);
      getTraineredit({ trainer_user_id: row.trainer_user_id, type: 'get' }).then(res => {
        console.log(res);
        if (res.code == 200) {
          this.dialog.updateDialogStatus = true
          this.updateInfo = res.trainer
        }
      })
    },
    //重置密码
    setpwd(row) {
      this.dialog.pwdDialogStatus = true
      this.setcards.trainer_user_id = row.trainer_user_id
    },
    setcard(row) {
      this.dialog.setDialogStatus = true
      this.setcards.trainer_user_id = row.trainer_user_id
    },
    submit() {
      setCard(this.setcards).then(res => {
        if (res.code == 200) {
          this.$message({ message: '操作成功', type: 'success' })
          this.closeForm()
        }
      }).catch(() => {
        this.loading = false
      })
    },
    submit1() {
      editPass(this.setcards).then(res => {
        if (res.code == 200) {
          this.$message({ message: '修改成功', type: 'success' })
          this.closeForm()
        }
      }).catch(() => {
        this.loading = false
      })
    },
    closeForm() {
      this.setcards.num = 0
      this.trainer_pass = ''
      this.dialog.setDialogStatus = false
      this.dialog.pwdDialogStatus = false

    },
    //删除
    del(row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        getTrainerdelete({ trainer_user_id: row.trainer_user_id }).then(res => {
          this.$message({ message: '删除成功', type: 'success' })
          this.getdata()
        })
      })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    getdata() {
      this.loading = true
      getTrainer(this.formInline).then(res => {
        this.loading = false
        if (res == false) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.listData = res.trainer.data
          // 分页赋值
          this.pageparm.currentPage = res.trainer.current_page
          this.pageparm.pageSize = res.trainer.per_page
          this.pageparm.total = res.trainer.total
        }
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.formInline.page = 1
      this.getdata(this.formInline)
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.dialog-footer {
  margin: 40px 0px 0px 310px;
}

.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/coach/Coach.vue